// frontend/src/CreateEvent.js
import React, { useState } from 'react';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import './CreateEvent.css';

function CreateEvent({ onClose, onSave }) {
  const [name, setName] = useState('');
  const [location, setLocation] = useState('');
  const [time, setTime] = useState('');
  const [coordinates, setCoordinates] = useState({ lat: null, lng: null });

  // When a location is selected from the autocomplete suggestions,
  // fetch its geocode to get precise coordinates.
  const handleSelect = async (value) => {
    setLocation(value);
    try {
      const results = await geocodeByAddress(value);
      const { lat, lng } = await getLatLng(results[0]);
      setCoordinates({ lat, lng });
    } catch (error) {
      console.error('Error getting geocode: ', error);
    }
  };

  const handleSave = () => {
    if (name.trim() && location.trim() && time.trim()) {
      // Pass coordinates along with the other event details.
      onSave({
        name,
        location,
        time,
        location_lat: coordinates.lat,
        location_lng: coordinates.lng,
      });
    }
  };

  return (
    <div className="create-event-modal">
      <div className="modal-content">
        {/* Cancel as Cross */}
        <button className="close-button" onClick={onClose}>
          &times;
        </button>

        <h2>Create Event</h2>
        <input
          type="text"
          placeholder="Event Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <PlacesAutocomplete
          value={location}
          onChange={setLocation}
          onSelect={handleSelect}
        >
          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
            <div className="location-autocomplete-wrapper">
              <input
                {...getInputProps({
                  placeholder: 'Location',
                  className: 'location-input',
                })}
              />
              <div className="autocomplete-dropdown-container">
                {loading && <div>Loading...</div>}
                {suggestions.map((suggestion) => {
                  const className = suggestion.active
                    ? 'suggestion-item--active'
                    : 'suggestion-item';
                  const style = suggestion.active
                    ? { backgroundColor: '#a8dadc', cursor: 'pointer' }
                    : { backgroundColor: '#ffffff', cursor: 'pointer' };

                  return (
                    <div
                      {...getSuggestionItemProps(suggestion, { className, style })}
                      key={suggestion.placeId}
                    >
                      <span>{suggestion.description}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </PlacesAutocomplete>

        <input
          type="datetime-local"
          value={time}
          onChange={(e) => setTime(e.target.value)}
        />
        <div className="modal-actions">
          <button onClick={handleSave}>Save</button>
        </div>
      </div>
    </div>
  );
}

export default CreateEvent;

